import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Loader({ containerSize = '1.5rem' }) {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      width: containerSize,
      height: containerSize
    }}>
      <CircularProgress 
        sx={{ 
          color: 'white',
          width: '100% !important',
          height: '100% !important',
          minWidth: '1rem',
          minHeight: '1rem',
          maxWidth: '3rem',
          maxHeight: '3rem'
        }} 
      />
    </Box>
  );
}